import { Form } from 'factorial-form'

function countryMetadata(country: string | null | undefined) {
  switch (country) {
    case 'es':
      return {
        has_work_permit: 'boolean',
        social_security_number: 'string',
      }

    default:
      return {}
  }
}

class IdentificationForm extends Form {
  constructor(values: Record<string, unknown>, country: string | null | undefined) {
    super(values, {
      identifier: 'string',
      identifier_type: 'string',
      identifier_expiration_date: 'date',
      country_metadata: countryMetadata(country),
    })
  }
}

export default IdentificationForm
